import React from 'react';

import { InputView } from '@infoods/lifebase-ui';

import { FormFieldsGrid } from '../../FormFieldsGrid/FormFieldsGrid';

import classes from './ViewFaqRow.module.scss';
import { RichTextViewer } from '../../../../../shared/features/rich-text';

type ViewFaqRowProps = {
  question: string;
  answer: string;
};

export const ViewFaqRow = ({ question, answer }: ViewFaqRowProps) => {
  return (
    <FormFieldsGrid mode="VIEW">
      <div className={classes.questionColumn}>{question}</div>
      <div className={classes.answerColumn}>
        <InputView
          label="Answer"
          value={<RichTextViewer content={answer} />}
          valueFont="inherit"
        />
      </div>
    </FormFieldsGrid>
  );
};
